import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CalendarService {
    private refreshCalendarSource = new Subject<void>();
    refreshCalendar$ = this.refreshCalendarSource.asObservable();

    private workflowCalendarUpdateSource = new Subject<{startDate: string, endDate: string, teamLeaderFor?: number}>();
    workflowCalendarUpdate$ = this.workflowCalendarUpdateSource.asObservable();

    triggerRefreshCalendar() {
        this.refreshCalendarSource.next();
    }

    triggerWorkflowCalendarUpdate(startDate: string, endDate: string, teamLeaderFor = 0) {
        this.workflowCalendarUpdateSource.next({startDate, endDate, teamLeaderFor});
    }
}
